import { searchExpenseTableColumns } from "../../../mock/SearchExpenses";

const SearchExpenseTable = () => {
  return (
    <div className="table-responsive">
      <table className="table table-striped table-hover w-100">
        <thead className="table-dark">
          <tr>
            {searchExpenseTableColumns.map((item) => (
              <td key={item.id}>{item.name}</td>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
        <thead className="table-dark">
          <tr>
            {searchExpenseTableColumns.map((item) => (
              <td key={item.id}>{item.name}</td>
            ))}
          </tr>
        </thead>
      </table>
    </div>
  );
};

export default SearchExpenseTable;
